"use client";
import { cn } from "@/lib/utils";
import { notFound } from "next/navigation";
import { useEffect } from "react";

export default function BlogContent({ description }: { description: string }) {
  useEffect(() => {
    const youtubeIframes = document.querySelectorAll(
      'iframe[src*="youtube-nocookie.com"]',
    ) as unknown as HTMLIFrameElement[];

    if (!Array.isArray(youtubeIframes) || !youtubeIframes.length) return;

    youtubeIframes.forEach((iframe) => {
      iframe.addEventListener("touchstart", function (e) {
        e.preventDefault();
      }, {
        passive: true,
      });
    });

    return () => {
      if (!Array.isArray(youtubeIframes) || !youtubeIframes.length) return;

      youtubeIframes.forEach((iframe) => {
        iframe.removeEventListener("touchstart", () => {});
      });
    };
  }, []);

  if (!description) return notFound();

  return (
    <div className={cn("w-full block flex-col items-center relative")}>
      <div
        className="custom-content-styles"
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
    </div>
  );
}
